import { FC } from 'react';
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from '@/components/ui/tooltip';
import Icon from 'Components/Icon';

interface PriceReasonIconProps {
  reason: string;
}

export const PriceReasonIcon: FC<PriceReasonIconProps> = ({ reason }) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label={reason}
          className="tw:ml-2 tw:inline-flex tw:items-center tw:cursor-help tw:border-0 tw:bg-transparent tw:p-0"
        >
          <span aria-hidden="true">
            <Icon name="warning" size="small" className="tw:text-red-600" />
          </span>
        </button>
      </TooltipTrigger>
      <TooltipContent>{reason}</TooltipContent>
    </Tooltip>
  );
};
